import { ePlanLopTinChiActionsObj } from "../../action-types/lop-tin-chi/IPlanLopTinChiActions";
import { generateActions } from "../generateActions";

export const planLopTinChiActions = {
  ...generateActions(ePlanLopTinChiActionsObj, "PLAN_LOP_TIN_CHI"),
};
